<template>
  <div>
    <div class="form-group">
      <input type="text" placeholder="Buscar por R.F.C." class="form-control searchBox upperCaseTransform" style="" id="input_filter_by_rfc" v-model="rfc" />
    </div>
  </div>
</template>

<script>
import('@/assets/css/stylesheet.css')

export default {
  data() {
    return {
      rfc: "",
    }
  },
  name: 'SearchByRfcComponent',
  props: {
    list_to_filter: {
      type: Array,
      default: []
    }
  },
  watch: {
    rfc(val) {
      let listFiltered = [];

      if (val != "") {
        listFiltered = this.list_to_filter.filter(b => b.rfc.toUpperCase().includes(val.toUpperCase()));
      } else {
        listFiltered = this.list_to_filter;
      }

      this.$emit('filter-info-by-rfc', listFiltered);
    }
  },
  methods: {
  }
}
</script>